module.exports = __webpack_public_path__ + "static/media/bg-toned.21cb747b.jpg";